import { JUSIUrl, getQueryString } from './index'
//问卷发布 时间设置
export function defaultTime(isObj = true) {
  let arr = null;
  let d_str = new Date(2016, 9, 10, 9, 0);
  let d_end = new Date(2016, 9, 10, 18, 0);
  if (isObj) {
    arr = {
      1: [d_str, d_end],
      2: [d_str, d_end],
      3: [d_str, d_end],
      4: [d_str, d_end],
      5: [d_str, d_end],
      6: [d_str, d_end],
      7: [d_str, d_end],
    }
  } else {
    arr = [d_str, d_end]
  }
  return arr
}

export function defaultChecked(zs = 1) {
  if (zs == 1) { //正数
    return {
      1: false,
      2: false,
      3: false,
      4: false,
      5: false,
      6: false,
      7: false,
    }
  } else {
    return {
      '-1': false,
      '-2': false,
      '-3': false,
      '-4': false,
      '-5': false,
    }
  }
}

export const dateKey = 'week_'

//手机号验证
export function phoneCheck(str) {
  var reg = /^1[23456789]\d{9}$/;
  if (reg.test(str)) {
    return true;
  } else {
    return false;
  }
}

//自检 获取提交答案数据
export function getQuestion(item) {
  let ans = null;
  let img = [];
  let instructions = ''
  if (item.type <= 3) {
    ans = item.options.filter(ss => ss.checked).map(s => { return s.label });
    if (ans != 3) {
      ans = ans[0]
    }
    if (item.type == 1) {
      img = item.options.filter(ss => ss.checked)[0].imgs;
      instructions = item.options.filter(ss => ss.checked)[0] ? item.options.filter(ss => ss.checked)[0].instructions : '';
    }

    if (item.type == 1) {
      let inx = 0
      item.options.map((r, s) => {
        if (r.checked) {
          inx = s + 1
        }
      })
      ans = inx;
    }
  } else {
    ans = item.awtext
  }
  return {
    id: item.id,
    answer: ans,
    imgs: img ? img.map(s => { return s.url ? s.url : s }) : [],
    explain: item.type != 1 ? '' : instructions
  }
}


export function uploadImg(upFiles) {
  const self = this // 绑定this
  // console.log(upFiles,'www');

  const reader = new FileReader() //实例化一个reader文件
  reader.readAsDataURL(upFiles) // 添加二进制文件
  return new Promise((resolve, reject) => {
    reader.onload = function (event) {
      const base64 = event.target.result // 获取到它的base64文件
      
      // self.compressImg(base64, scale, self.uploadFileAjx) // 调用压缩方法
      const img = new Image()
      img.src = base64
      resolve(img);
    }
  })
}
export function readerOnload(img) {
  let scale = 0.7 // 设置缩放比例 （0-1） 
  return new Promise((resolve, reject) => {
    img.onload = function () {
      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')
      canvas.setAttribute('width', this.width)
      canvas.setAttribute('height', this.height)
      ctx.clearRect(0, 0, canvas.width, canvas.height)
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height)
      // 转成base64 文件
      let base64 = canvas.toDataURL('image/jpeg')
      // 根据自己需求填写大小 我的目标是小于3兆
      while (base64.length > 1024 * 1024 * 3) {
        scale -= 0.01
        base64 = canvas.toDataURL('image/jpeg', scale)
      }
      const arr = base64.split(',');
      const mime = arr[0].match(/:(.*?);/)[1];
      const bytes = atob(arr[1])
      const bytesLength = bytes.length
      const u8arr = new Uint8Array(bytesLength)
      for (let i = 0; i < bytes.length; i++) {
        u8arr[i] = bytes.charCodeAt(i)
      }
      const blob = new Blob([u8arr], {
        type: mime
      })
      // 回调函数 根据需求返回二进制数据或者base64数据
      // callback(blob, base64)
      resolve(blob);
    }
  })

}

